import { usePageArchiveMutations } from './usePageArchiveMutations';
import { usePageContentMutation } from './usePageContentMutation';
import { usePageCreateMutation } from './usePageCreateMutation';
import { usePagePublishMutation } from './usePagePublishMutation';
import { usePageSyncImport } from './usePageSyncImport';
import { usePageTitleMutation } from './usePageTitleMutation';

/**
 * Page mutation surface for UI components.
 *
 * Each mutation persists through PageRepository and refreshes reads via query
 * invalidation; components that only need one action can import its focused
 * hook directly.
 */
export function usePageActions() {
  const addPage = usePageCreateMutation();
  const updatePageTitle = usePageTitleMutation();
  const updatePageContent = usePageContentMutation();
  const { archivePage, deletePage, unarchivePage } = usePageArchiveMutations();
  const toggleIsPublic = usePagePublishMutation();
  const syncRemoteWithLocal = usePageSyncImport();

  return {
    addPage,
    updatePageTitle,
    updatePageContent,
    deletePage,
    toggleIsPublic,
    archivePage,
    unarchivePage,
    syncRemoteWithLocal,
  };
}
